export const EMAIL_PATTERN = '[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*';
export const TEL_PATTERN = '[0-9]+';
export const MOBILE_NUMBER_PATTERN = '(060|070|080|090)\\d{8}';

export const EMAIL_REG = new RegExp(`^${EMAIL_PATTERN}$`);
export const TEL_REG = new RegExp(`^${TEL_PATTERN}$`);
export const MOBILE_NUMBER_REG = new RegExp(`^${MOBILE_NUMBER_PATTERN}$`);
export const NAME_KANA = new RegExp('^[ァ-ヶー]*[\x20\u3000]?[ァ-ヶー]*$');
export const BIRTHDAY = new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}$');
